var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M19.596 17.786c.566-.649.904-1.435.904-2.286 0-2.209-2.238-4-5-4-2.761 0-5 1.791-5 4 0 2.21 2.239 4 5 4 .783 0 1.514-.156 2.174-.413L20.5 20.5zM15.5 11.5c1.544 0 2.907.571 3.824 1.451.745-1.018 1.176-2.195 1.176-3.451 0-3.866-4.029-7-9-7s-9 3.134-9 7c0 1.62.714 3.107 1.902 4.294L3.5 16.5l2.701-1.351c1.273.723 2.801 1.175 4.455 1.297a3.22 3.22 0 0 1-.156-.946c0-2.209 2.238-4 5-4z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgChat as ReactComponent };
export default __webpack_public_path__ + "8f87eff39e8091ec03238f3b066ddfda.svg";